import "./Branches.css";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import data from "./branches.json";
import { useState, useEffect } from "react";

const Branches = () => {
  const [active, setActive] = useState(0);
  const [branchInfo, setBranchInfo] = useState({
    branch_name: data[0].branch_name,
    address: data[0].address,
    phone: data[0].contact,
    location: data[0].location,
  });
  const handleBranchChange = (branch_name) => {
    const temp_info = data.find((item) => item.branch_name === branch_name);
    setBranchInfo({
      branch_name: temp_info.branch_name,
      address: temp_info.address,
      phone: temp_info.contact,
      location: temp_info.location,
    });
  };

  return (
    <>
      <Container fluid className="branch_root" id="branches">
        <Container className="branch_container">
          <div className="branch_title">
            <h3>Our Branches</h3>
            <hr className="branch_line"></hr>
            <p className="branch_descrip">
              Our strategically located branches in MH, CG, and MP make us
              accessible to customers across India, as well as those who require
              our products and services overseas. We pride ourselves on offering
              comprehensive pan-India and export services for all our products,
              ensuring that you can always access the spares you need, no matter
              where you are located.
            </p>
          </div>

          <Row className="branch_wrapper">
            <Col lg={6} className="branch_left">
              <div className="branch_left_title">
                <h4>Locations</h4>
              </div>
              <div className="branch_button_wrapper">
                {data.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      handleBranchChange(item.branch_name);
                      setActive(index);
                    }}
                    className={active === index && `active`}
                  >
                    {item.branch_name}
                  </button>
                ))}
              </div>
            </Col>
            <Col lg={6}>
              <div className="branch_right">
                <h4>{branchInfo.branch_name}</h4>
                <div className="fadein">
                  <p>
                    <span style={{ fontWeight: "700" }}>Address : </span>
                    <br />
                    {branchInfo.address}
                  </p>
                  <p>
                    <span style={{ fontWeight: "700" }}>Phone number :</span>{" "}
                    <br />
                    {branchInfo.phone}
                  </p>
                  <div className="branch-google-maps">
                    <p style={{ fontWeight: "700" }}>Find us here :</p>
                    <iframe
                      title="gmaps"
                      src={branchInfo.location}
                      style={{
                        border: 0,
                        borderRadius: "5px",
                      }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};
export default Branches;
